import React, { useEffect, useState } from 'react';
import {
  Home as HomeOutlined,
} from '@mui/icons-material';
import { Link } from 'react-router-dom';
import { Gradient } from '../AdminHeader/Gradient.js';
import { useTranslation } from 'react-i18next';
import i18n from '../../i18n/index';

const gradient = new Gradient();

const SUPPORT_EMAIL = 'support@headshotsnow.ai';

const AcceptableUse = () => {
  const [currentLanguage, setCurrentLanguage] = useState('');

  const { t } = useTranslation();

  useEffect(() => {
    gradient.initGradient('#canvas-gradient');
    window.scrollTo(0, 0);
    return () => { };
  }, []);

  useEffect(() => {
    setCurrentLanguage(i18n.language);
  }, [i18n.language]);

  const homeHref = currentLanguage === 'en' ? '/' : `/${currentLanguage}/`;

  return (
    <>
      <main style={{ background: '#000' }}>
        <div className="landing-cover" data-controller="gradient-animation">
          <div className="container">
            <div className="d-flex flex-column align-items-center">
              <h1 className="display-1 fw-semi-bold text-white text-center mb-5 mb-sm-4">Acceptable Use Policy</h1>
              <Link to={homeHref} className="btn btn-soft-light btn-sm rounded-pill tag text-nowrap">
                <HomeOutlined />
                {t('button.backHome')}
              </Link>
            </div>
          </div>
          <canvas id="canvas-gradient" data-transition-in />
          <div id="canvas-overlay" />
        </div>
      </main>
      <section className="bg-white text-black">
        <div className="container mx-auto p-6 max-w-4xl">
          <p className="mb-4">
            HeadshotsNow.ai exists to help people create professional headshots of themselves. To keep the service safe
            and lawful, you agree not to use it for any of the following. Violations may result in immediate suspension or
            termination, and where appropriate, reporting to the relevant authorities.
          </p>

          <h2 className="text-2xl font-bold mb-2">Prohibited Uses</h2>
          <p className="mb-2">You may <span className="font-semibold">not</span> use HeadshotsNow.ai to:</p>
          <ul className="list-disc list-inside mb-4" style={{ paddingLeft: '1.5em' }}>
            <li>Create fake identification or government documents (passports, driver&rsquo;s licenses, ID cards, etc.).</li>
            <li>Impersonate any person or organization, or commit fraud or any deceptive act.</li>
            <li>Generate adult, sexual, nude, or otherwise explicit content.</li>
            <li>Harass, threaten, defame, or bully any person.</li>
            <li>Create political deception, disinformation, or content intended to mislead voters.</li>
            <li>Engage in any illegal activity or violate any applicable law or regulation.</li>
            <li>Create misleading deepfakes or content that falsely depicts real events or statements.</li>
            <li>Upload photos of a person without their explicit permission, or photos you do not have the rights to use.</li>
            <li>Infringe the intellectual property, privacy, or other rights of any third party.</li>
            <li>Violate the terms or policies of any platform where you publish the images.</li>
          </ul>

          <h2 className="text-2xl font-bold mb-2">Your Responsibility</h2>
          <p className="mb-4">
            You are responsible for the photos you upload and for how you use the headshots you receive. By using the
            service you confirm that you have the right to upload your photos and that your use complies with this policy
            and our <Link to="/legal" className="underline">Terms of Service</Link>.
          </p>

          <h2 className="text-2xl font-bold mb-2">Reporting</h2>
          <p className="mb-4">
            To report misuse or a violation of this policy, contact {SUPPORT_EMAIL}.
          </p>

          <p className="mb-4 font-bold">Last updated: 18 June 2026</p>
        </div>
      </section>
    </>
  );
};

export default AcceptableUse;
